module.exports = __webpack_public_path__ + "img/jinyafu1.4388cda8.jpg";